class BaseHero extends Component {
    constructor(el) {
        super(el);
        this.swiperEl = this.$find('[data-swiper]');
        this.swiper = null;
        this.swiperEl && this.constructSwiper();
        this.addEventListeners();
    }

    constructSwiper() {
        this.swiper = new Swiper(this.swiperEl, {
            watchOverflow: true,
            pagination: (document.querySelectorAll('[data-swiper-slide]').length <= 1) ? false : {
                el: '[data-hero-pagination]',
                clickable: true
            },
            autoplay: {
                delay: 5000,
            },
            grabCursor: true,
        });
    }

    addEventListeners() {
        this.swiperEl.addEventListener('mouseenter', () => {
            this.swiper.autoplay.stop();
        });
        this.swiperEl.addEventListener('mouseleave', () => {
            this.swiper.autoplay.start();
        });
    }
}
